<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [dataLabels]="chartOptions.dataLabels!"
        [plotOptions]="chartOptions.plotOptions!"
        [responsive]="chartOptions.responsive!"
        [grid]="chartOptions.grid!"
        [xaxis]="chartOptions.xaxis!"
        [yaxis]="chartOptions.yaxis!"
        [colors]="chartOptions.colors!"
        [legend]="chartOptions.legend!"
        [fill]="chartOptions.fill!"
    ></apx-chart>
</div>